__turbopack_context__.v({
  "radioButton": "GalleryFilterCategories-module-scss-module__BhjpqW__radioButton",
  "selector": "GalleryFilterCategories-module-scss-module__BhjpqW__selector",
  "selector__box": "GalleryFilterCategories-module-scss-module__BhjpqW__selector__box",
  "selector__group": "GalleryFilterCategories-module-scss-module__BhjpqW__selector__group",
  "selector__switch": "GalleryFilterCategories-module-scss-module__BhjpqW__selector__switch",
  "selector__title": "GalleryFilterCategories-module-scss-module__BhjpqW__selector__title",
});
